import { inject } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router'
import {isADITenant, isIntelTenant} from 'src/app/services/common/common.service'
import { LocalStorageService } from '../services/common/local-storage.service'

export const loginOnlyRedirectGuard = (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  hostnameOverride?: string
) => {
  const router = inject(Router)

  if (isIntelTenant(hostnameOverride)) {
    router.navigate(['/login', 'INTEL'])
    LocalStorageService.set('companyDomain', 'INTEL')
  } else if (isADITenant(hostnameOverride)) {
    router.navigate(['/login', 'ADI'])
    LocalStorageService.set('companyDomain', 'ADI')
  } else {
    router.navigate(['/'])
  }

  return false
}
